export const DEFAULT_RESOLUTION = 'Auto';

export const DEFAULT_SOURCE = { 
  src: 'Auto', 
  type: 'application/x-mpegURL', 
  label: 'Auto', 
  bandwidth: 'Auto' 
};